export class Message {
    constructor(
        public content: string, 
        public sentBy: string, 
        public sentDate: any) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/model/chatbot.message.model.ts